/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useReducer, useEffect, useMemo, useState } from "react";
import avatar from "../../../images/avatar/profile_avatar.png";
import build from "../../../../package.json";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
import config from "../../../config";
/// Link
import { Link, useNavigation } from "react-router-dom";
import profile from "../../../images/profile/pic1.jpg";
import { MenuList } from "./Menu";
import { useTranslation } from "react-i18next";
import { fetchProfileCompleteNumber } from "../../../services/UserServices";
import formatError from "../../../services/FormatError";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

function SideBar() {
  const { t } = useTranslation();
  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"));

  const [state, setState] = useReducer(reducer, initialState);

  // let handleheartBlast = document.querySelector('.heart');
  const menuLists = MenuList();
  const updatedMenusList = useMemo(() => {
    let updatedMenu = [];

    if (
      ctxObj?.result?.role?.id === 3 &&
      ctxObj?.result.hasOwnProperty("loggedinprofileid") &&
      (ctxObj?.result?.loggedinprofiletype === "buyerprofile" ||
        ctxObj?.result?.loggedinprofiletype === "sellerprofile")
    ) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.to !== "users" &&
          eachItem?.title !== t("sidebarItemSystemConfiguration") &&
          eachItem?.title !== t("sidebarItemProfiles") &&
          eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.title !== t("createBuyerProfile") &&
          eachItem?.title !== t("createSellerProfile") &&
          eachItem?.to !== "contracttypes" &&
          eachItem?.to !== "currencies" &&
          eachItem?.to !== "templatemanagement" &&
          //   eachItem?.title !== "Documents" &&
          eachItem?.to !== "roles" &&
          eachItem?.to !== "message-template" &&
          eachItem?.to !== "event-config" &&
          eachItem?.to !== "outbox" &&
          eachItem?.to !== "tenant" &&
          eachItem?.to !== "rates" &&
          eachItem?.to !== "report" &&
          eachItem?.to !== "assignbusiness" &&
          eachItem?.to !== "requested-business"
      );

      // Additional filtering based on existing profiles
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }
    } else if (
      ctxObj?.result?.role?.id === 3 &&
      ctxObj?.result.hasOwnProperty("loggedinprofileid") &&
      ctxObj?.result?.loggedinprofiletype === "professionalprofile"
    ) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.to !== "users" &&
          eachItem?.title !== t("createBuyerProfile") &&
          eachItem?.title !== t("createSellerProfile") &&
          eachItem?.title !== t("sidebarItemSystemConfiguration") &&
          eachItem?.title !== t("sidebarItemProfiles") &&
          eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.to !== "offers" &&
          eachItem?.to !== "contracttypes" &&
          eachItem?.to !== "contracts" &&
          eachItem?.to !== "currencies" &&
          eachItem?.to !== "templatemanagement" &&
          //   eachItem?.title !== "Documents" &&
          eachItem?.to !== "roles" &&
          eachItem?.to !== "message-template" &&
          eachItem?.to !== "event-config" &&
          eachItem?.to !== "outbox" &&
          eachItem?.to !== "tenant" &&
          eachItem?.to !== "rates" &&
          eachItem?.to !== "report" &&
          eachItem?.to !== "assignbusiness" &&
          eachItem?.to !== "requested-business"
      );
      // Additional filtering based on existing profiles in user object
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }
    } else if (ctxObj?.result?.role?.id === 3) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.title !== t("sidebarItemSystemConfiguration") &&
          eachItem?.title !== t("sidebarItemProfiles") &&
          // eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.to !== "dashboard" &&
          eachItem?.to !== "users" &&
          eachItem?.to !== "offers" &&
          eachItem?.to !== "contracttypes" &&
          eachItem?.to !== "contracts" &&
          eachItem?.to !== "currencies" &&
          eachItem?.to !== "templatemanagement" &&
          //   eachItem?.title !== "Documents" &&
          eachItem?.to !== "roles" &&
          eachItem?.to !== "message-template" &&
          eachItem?.to !== "event-config" &&
          eachItem?.to !== "outbox" &&
          eachItem?.to !== "tenant" &&
          eachItem?.to !== "rates" &&
          eachItem?.to !== "report" &&
          eachItem?.to !== "assignbusiness" &&
          eachItem?.to !== "requested-business"
      );

      // Additional filtering based on existing profiles in user object
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }
    } else if (ctxObj?.result?.role?.id === 4) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.title !== t("sidebarItemSystemConfiguration") &&
          eachItem?.to !== "dashboard" &&
          eachItem?.title !== t("createBuyerProfile") &&
          eachItem?.title !== t("createSellerProfile") &&
          eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.to !== "business" &&
          eachItem?.to !== "users" &&
          eachItem?.to !== "offers" &&
          eachItem?.to !== "contracttypes" &&
          eachItem?.to !== "currencies" &&
          eachItem?.to !== "templatemanagement" &&
          eachItem?.to !== "roles" &&
          eachItem?.to !== "message-template" &&
          eachItem?.to !== "event-config" &&
          eachItem?.to !== "outbox" &&
          eachItem?.to !== "tenant" &&
          eachItem?.to !== "rates" &&
          eachItem?.to !== "report" &&
          eachItem?.title !== "Profiles" &&
          eachItem?.title !== "Profils"
      );

      // Additional filtering based on existing profiles in user object
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }
    } else if (ctxObj?.result?.role?.id === 5) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.title !== t("sidebarItemSystemConfiguration") &&
          eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.to !== "dashboard" &&
          eachItem?.to !== "business" &&
          eachItem?.to !== "users" &&
          eachItem?.title !== t("createBuyerProfile") &&
          eachItem?.title !== t("createSellerProfile") &&
          eachItem?.to !== "offers" &&
          eachItem?.to !== "contracttypes" &&
          eachItem?.to !== "contracts" &&
          eachItem?.to !== "currencies" &&
          eachItem?.to !== "templatemanagement" &&
          eachItem?.to !== "roles" &&
          eachItem?.to !== "message-template" &&
          eachItem?.to !== "event-config" &&
          eachItem?.to !== "outbox" &&
          eachItem?.to !== "tenant" &&
          eachItem?.to !== "rates" &&
          eachItem?.to !== "report" &&
          eachItem?.title !== "Profiles" &&
          eachItem?.title !== "Profils"
      );

      // Additional filtering based on existing profiles in user object
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }
    } else if (ctxObj?.result?.role?.id === 1) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.to !== "assignbusiness" &&
          eachItem?.to !== "requested-business" &&
          eachItem?.title !== t("createBuyerProfile") &&
          eachItem?.title !== t("createSellerProfile") &&
          eachItem?.title !== t("sidebarItemBuyerProfile") &&
          eachItem?.title !== t("sidebarItemSellerProfile")
      );

      // Additional filtering based on existing profiles in user object
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) =>
            eachItem?.title !== t("createSellerProfile") &&
            eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) =>
            eachItem?.title !== t("createBuyerProfile") &&
            eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }
    } else if (ctxObj?.result?.role?.id === 2) {
      updatedMenu = menuLists.filter(
        (eachItem) =>
          eachItem?.title !== t("sidebarItemProfilesUser") &&
          eachItem?.to !== "assignbusiness" &&
          eachItem?.title !== t("createBuyerProfile") &&
          eachItem?.title !== t("createSellerProfile") &&
          eachItem?.title !== t("sidebarItemBuyerProfile") &&
          eachItem?.title !== t("sidebarItemSellerProfile") &&
          eachItem?.to !== "requested-business"
      );

      // Additional filtering based on existing profiles in user object
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      }
    } else {
      // Start with full menu and filter based on user profiles
      updatedMenu = [...menuLists];

      // Filter based on existing profiles
      if (ctxObj?.result?.user?.sellerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createSellerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemSellerProfile")
        );
      }

      if (ctxObj?.result?.user?.buyerprofile?.id) {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("createBuyerProfile")
        );
      } else {
        updatedMenu = updatedMenu.filter(
          (eachItem) => eachItem?.title !== t("sidebarItemBuyerProfile")
        );
      }

      // If no profiles exist, hide assignbusiness
      if (
        !ctxObj?.result?.user?.sellerprofile?.id &&
        !ctxObj?.result?.user?.buyerprofile?.id
      ) {
        updatedMenu = updatedMenu.filter(
          (eachItem) =>
            eachItem?.to !== "assignbusiness" &&
            eachItem?.to !== "requested-business"
        );
      }
    }

    return updatedMenu;
  }, [ctxObj]);
  const [profileComplete, setProfileComplete] = useState(0);

  // const heartBlast = () => {
  //     return handleheartBlast.classList.toggle("heart-blast");
  // };

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  // ForAction Menu
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  // useEffect(() => {
  // 	console.log(ctxObj);
  // 	if (ctxObj.result.role === 3) {
  // 		fetchProfileCompletion();
  // 	}
  // }, []);

  useEffect(() => {
    if (
      ctxObj.result.role.id === 3 &&
      ctxObj.result.hasOwnProperty("loggedinprofiletype")
    ) {
      fetchProfileCompletion();
    }
    menuLists.forEach((data) => {
      data.content?.forEach((item) => {
        if (path === item.to) {
          setState({ active: data.title });
        }
        item.content?.forEach((ele) => {
          if (path === ele.to) {
            setState({ activeSubmenu: item.title, active: data.title });
          }
        });
      });
    });
  }, [path]);

  const fetchProfileCompletion = () => {
    fetchProfileCompleteNumber()
      .then((res) => {
        const response = res.data?.result;
        setProfileComplete(response);
      })
      .catch((error) => {
        formatError(error?.response.data?.error);
      });
  };
  return (
    <div className="d-flex flex-column justify-content-between align-items-start">
      <div
        className="deznav"
        style={{ backgroundColor: "#310247", color: "#ffffff" }}
      >
        <PerfectScrollbar className="deznav-scroll mb-4">
          <div className="main-profile mb-4">
            <div className="image-bx">
              <img
                src={
                  ctxObj?.result?.user?.PhotoKey
                    ? `${config.appUrl}file/view?key=${ctxObj?.result?.user?.PhotoKey}&type=IMAGE`
                    : avatar
                }
                alt="avatar"
              />
            </div>
            <h5 className="mb-0 fs-16 text-light">
              <span className="font-w400">{t("hello")},</span>{" "}
              {ctxObj?.result?.user?.username}
            </h5>
            <p className="mb-0 fs-12 font-w400">
              {ctxObj?.result?.user?.email}
            </p>
            {ctxObj?.result?.role?.id === 3 && (
              <div>
                <div
                  class="progress"
                  role="progressbar"
                  aria-label="Example with label"
                  // aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{
                    width: "50%",
                    height: "15px",
                    margin: "0 auto",
                    marginTop: "10px",
                  }}
                >
                  <div
                    class="progress-bar"
                    style={{ width: `${profileComplete}%` }}
                  >
                    {profileComplete}%
                  </div>
                </div>
                <p className="mb-0 fs-12 font-w400">{t("hprofileComplete")}</p>
              </div>
            )}
            <small className="d-block">
              (
              {ctxObj?.result?.loggedinprofiletype !== "sellerprofile" &&
                ctxObj?.result?.loggedinprofiletype !== "buyerprofile" &&
                ctxObj?.result?.role?.name}
              {ctxObj?.result?.loggedinprofiletype === "buyerprofile" &&
                t("endBuyer")}
              {ctxObj?.result?.loggedinprofiletype === "sellerprofile" &&
                t("hseller")}
              )
            </small>
          </div>

          <ul className="metismenu" id="menu" style={{ color: "#ffffff" }}>
            <li className="nav-label first" style={{ color: "#ffffff" }}>
              {t("sidebarTitle")}
            </li>
            {updatedMenusList.map((data, index) => {
              let menuClass = data.classsChange;
              if (menuClass === "nav-label") {
                return (
                  <li
                    key={index}
                    className={`has-menu text-light ${
                      state.active === data.title || data.to === path
                        ? "mm-active"
                        : ""
                    }`}
                    onClick={() => handleMenuActive(data.title)}
                  >
                    <Link to={data.to} className="text-light">
                      {data.iconStyle}
                      <span className="nav-text text-light">{data.title}</span>
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li
                    key={index}
                    className={`has-menu ${
                      state.active === data.title || data.to === path
                        ? "mm-active"
                        : ""
                    }`}
                  >
                    {data.content && data.content.length > 0 ? (
                      <Link
                        to={"#"}
                        onClick={() => handleMenuActive(data.title)}
                        className="has-arrow text-light"
                      >
                        {data.iconStyle}
                        <span className="nav-text text-light">
                          {data.title}
                        </span>
                      </Link>
                    ) : (
                      <Link to={data.to} className="text-light">
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                      </Link>
                    )}

                    <Collapse in={state.active === data.title ? true : false}>
                      <ul
                        className={`${
                          menuClass === "mm-collapse" ? "mm-show" : ""
                        }`}
                      >
                        {data.content &&
                          data.content.map((data, index) => {
                            return (
                              <li
                                key={index}
                                className={`${
                                  state.activeSubmenu === data.title
                                    ? "mm-active"
                                    : ""
                                }`}
                              >
                                {data.content && data.content.length > 0 ? (
                                  <>
                                    <Link
                                      to={data.to}
                                      className={
                                        data.hasMenu ? "has-arrow" : ""
                                      }
                                      onClick={() =>
                                        handleSubmenuActive(data.title)
                                      }
                                    >
                                      {data.title}
                                    </Link>
                                    <Collapse
                                      in={
                                        state.activeSubmenu === data.title
                                          ? true
                                          : false
                                      }
                                    >
                                      <ul
                                        className={` ${
                                          menuClass === "mm-collapse"
                                            ? "mm-show"
                                            : ""
                                        }`}
                                      >
                                        {data.content &&
                                          data.content.map((data, index) => {
                                            return (
                                              <>
                                                <li key={index}>
                                                  <Link
                                                    className={`${
                                                      path === data.to
                                                        ? "mm-active"
                                                        : ""
                                                    }`}
                                                    to={data.to}
                                                  >
                                                    {data.title}
                                                  </Link>
                                                </li>
                                              </>
                                            );
                                          })}
                                      </ul>
                                    </Collapse>
                                  </>
                                ) : (
                                  <Link
                                    to={data.to}
                                    className={`sidebar-nested-link ${
                                      data.to === path ? "mm-active" : ""
                                    }`}
                                  >
                                    {data.title}
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                      </ul>
                    </Collapse>
                  </li>
                );
              }
            })}
          </ul>
        </PerfectScrollbar>

        <div
          className="mt-4 nav-text"
          style={{
            position: "absolute",
            bottom: "5px",
            left: "0px",
            right: "0px",
            padding: "0px 5px",
            textAlign: "center",
          }}
        >
          <span
            style={{
              fontSize: "11px",
              margin: 0,
              lineHeight: "1.4",
            }}
            className="text-muted"
          >
            © AMG Global {new Date().getFullYear()} <br />
            {t("loginCopyright")}
            {t("hbuild")}: {build.build}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
